"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCHING_OPTION = exports.MAX_MENU_HEIGHT = exports.AVERAGE_OPTION_HEIGHT = void 0;
exports.AVERAGE_OPTION_HEIGHT = 32;
exports.MAX_MENU_HEIGHT = 150;
exports.SEARCHING_OPTION = {
    value: Math.random(),
    label: 'Searching...',
};
